module.exports = __webpack_public_path__ + "static/media/BEETS.92398524.png";